import React, { lazy, Suspense } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import App from "./App";
import AccessGate, {
  BILLING_PATHNAME,
  BillingPage,
  WIZARD_PATHNAME,
  WizardPage,
} from "./components/AccessGate";
import { DEFAULTS_PATHNAME, PREVIEW_PATHNAME } from "./utils/constants";

import "ol/ol.css";
import "./App.scss";
import "./Globals.module.scss";

const Root = lazy(() => {
  return import("./components/Root");
});
const PlanPreview = lazy(() => {
  return import("./components/PlanPreview");
});
const PlanDefaults = lazy(() => {
  return import("./components/PlanDefaults");
});

function AppRouter({ permalink = null }: { permalink?: null | string }) {
  // TODO do we still need this?
  if (permalink) {
    // app is loaded as es6 module
    return (
      <App>
        <PlanPreview permalink={permalink} />
      </App>
    );
  }

  return (
    <Router>
      <Suspense fallback={<div />}>
        <Routes>
          <Route
            element={
              <App>
                <PlanPreview />
              </App>
            }
            path={PREVIEW_PATHNAME}
          />
          <Route
            element={
              <App>
                <PlanDefaults />
              </App>
            }
            path={DEFAULTS_PATHNAME}
          />
          <Route
            element={
              <App>
                <WizardPage />
              </App>
            }
            path={WIZARD_PATHNAME}
          />
          <Route
            element={
              <App>
                <BillingPage />
              </App>
            }
            path={BILLING_PATHNAME}
          />
          <Route
            element={
              <App>
                <AccessGate>
                  <Root />
                </AccessGate>
              </App>
            }
            path="/"
          />
          <Route element={<Navigate to="/" />} path="/*" />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default React.memo(AppRouter);
